// Accept both existing API serialization conventions; never render model HTML/URLs.
const field = (value, name) => value?.[name] ?? value?.[name[0].toUpperCase() + name.slice(1)];

export function guideAssetUrl(path, baseUrl = process.env.REACT_APP_API_URL) {
  if (!/^ai-guides\/[a-z0-9-]+\/v\d+\/\d{2}\.(jpg|png)$/.test(path || "")) return null;
  try {
    const base = new URL(baseUrl || "/api", window.location.origin);
    if (!["http:", "https:"].includes(base.protocol)) return null;
    // Remove the controller's final /api, preserving an IIS virtual application prefix.
    base.pathname = base.pathname.replace(/\/api\/?$/i, "").replace(/\/$/, "") + "/";
    base.search = "";
    base.hash = "";
    return new URL(path, base).href;
  } catch { return null; }
}

export function normalizeVisualGuide(value) {
  if (!value || field(value, "platform") !== "mobile") return null;
  const rawSteps = field(value, "steps");
  if (!Array.isArray(rawSteps) || rawSteps.length === 0 || rawSteps.length > 30) return null;
  const steps = rawSteps.map((step) => {
    const imageUrl = guideAssetUrl(field(step, "imagePath"));
    const bounds = field(step, "highlight");
    const highlight = Array.isArray(bounds) && bounds.length === 4 &&
      bounds.every((n) => Number.isFinite(n) && n >= 0 && n <= 100) &&
      bounds[0] + bounds[2] <= 100 && bounds[1] + bounds[3] <= 100 ? bounds : null;
    return { id: field(step, "id"), title: field(step, "title"), instruction: field(step, "instruction"),
      note: field(step, "note"), imageUrl, highlight };
  });
  if (steps.some((s) => !s.imageUrl || !s.title || !s.instruction)) return null;
  const start = field(value, "startStep");
  return { id: field(value, "id"), version: field(value, "version"), title: field(value, "title"), audience: field(value, "audience"),
    summary: field(value, "summary"), languageCode: field(value, "languageCode") || "en",
    screenshotLanguageCode: field(value, "screenshotLanguageCode") || "en",
    startStep: Number.isInteger(start) ? Math.max(0, Math.min(start, steps.length - 1)) : 0, steps };
}
